import useRouter from '~/client/hooks/router/useRouter';
import useGameLoginProtected from './useGameLoginProtected';

const useGameRedirect = () => {
  const { push } = useRouter();
  const { redirectTo: redirectToLogin } = useGameLoginProtected();
  if (push) {
    if (redirectToLogin) {
      push(redirectToLogin);
    }
  }
  return { redirectTo: redirectToLogin };
};

export default useGameRedirect;
